import { scopedWarningMessage } from './scoped-messages.js';
function deprecationWarningMessage(options) {
    const { deadlineVersion, feature, property, replaced, replacement, scope, startingVersion } = options;
    if (feature) {
        scopedWarningMessage(scope, `The feature ${replaced} is deprecated since version ${startingVersion} and will be removed in version ${deadlineVersion}.`);
        return;
    }
    if (property) {
        scopedWarningMessage(scope, `The property ${replaced} is deprecated since version ${startingVersion} and will be removed in version ${deadlineVersion}`);
        return;
    }
    scopedWarningMessage(scope, `The method ${replaced} is deprecated since version ${startingVersion} and will be removed in version ${deadlineVersion}. Please use '${replacement}' instead.`);
}
export { deprecationWarningMessage, };
//# sourceMappingURL=deprecation-messages.js.map